module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_6005.a6651db3.png";